(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var initCdlRecommendationsCarousel = function (scope) {
    var $ = window.jQuery;
    if (!$) return;
    $(scope).find('.cdl-product-carousel[data-carousel-id]').each(function () {
      var $carousel = $(this);
      if ($carousel.hasClass('slick-initialized')) return;
      if (!$carousel.children('.cdl-carousel-slide').length) return;

      var perRow = parseInt($carousel.attr('data-per-row'), 10) || 4;
      var perRowTablet = parseInt($carousel.attr('data-per-row-tablet'), 10) || perRow;
      var perRowMobile = parseInt($carousel.attr('data-per-row-mobile'), 10) || perRow;
      var showArrows = $carousel.attr('data-arrows') === 'true';
      var showDots = $carousel.attr('data-dots') === 'true';
      var slidesToShow = perRow;
      var slidesToShowTablet = perRowTablet;
      var slidesToShowMobile = perRowMobile;

      function equalizeProductTitles() {
        var $titles = $carousel.find('.cdl-listing-title');
        if (!$titles.length) return;
        $titles.css('min-height', '0');
        var maxHeight = 0;
        $titles.each(function () {
          maxHeight = Math.max(maxHeight, this.getBoundingClientRect().height);
        });
        $titles.css('min-height', maxHeight + 'px');
      }

      $carousel.slick({
        slidesToShow: slidesToShow,
        slidesToScroll: perRow,
        arrows: showArrows,
        nextArrow: '<i class="fa fa-angle-right next_slide"></i>',
        prevArrow: '<i class="fa fa-angle-left prev_slide"></i>',
        dots: showDots,
        infinite: false,
        mobileFirst: false,
        responsive: [
          { breakpoint: 990, settings: { slidesToShow: slidesToShowTablet, slidesToScroll: perRowTablet } },
          { breakpoint: 750, settings: { slidesToShow: slidesToShowMobile, slidesToScroll: perRowMobile } }
        ]
      });
      equalizeProductTitles();
    });
  };

  var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");

    if (productRecommendationsSection === null) { return; }
    var recommended_url = productRecommendationsSection.dataset.baseUrl;

    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;

    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;

    // Build request URL
    var requestUrl = recommended_url + '?section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;

    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        var parent = productRecommendationsSection.parentElement;
        parent.innerHTML = container.querySelector(".product-recommendations").innerHTML;
        // El swap de innerHTML no dispara shopify:section:load, así que el
        // carousel se inicializa a mano una vez que el HTML fresco está en el DOM.
        initCdlRecommendationsCarousel(parent);
      }
    };
    request.send();
  };
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
